import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { GenericState, IState } from '../../../common/store/types';
import {
  ContactChildrenLightModel,
  ContactDetailModel,
  ContactFormModel,
  ContactModel,
  ContactNameModel,
} from './types';
import { onApiCall } from '../../../common/store/generic.reducer';
import { contactActions } from './contact.actions';

export interface IContactState extends IState<ContactModel> {
  getById: GenericState<ContactDetailModel>;
  getFormById: GenericState<ContactFormModel>;
  postContact: GenericState<ContactModel>;
  updateContact: GenericState<ContactModel>;
  createInstance: GenericState<ContactModel>;
  getChildren: GenericState<ContactChildrenLightModel[]>;
  getNewestContactNameByEmail: GenericState<ContactNameModel>;
}

export const contactInitialState: IContactState = {
  getById: new GenericState<ContactDetailModel>(),
  getFormById: new GenericState<ContactFormModel>(),
  postContact: new GenericState<ContactModel>(),
  updateContact: new GenericState<ContactModel>(),
  createInstance: new GenericState<ContactModel>(),
  getChildren: new GenericState<ContactModel[]>(),
  getNewestContactNameByEmail: new GenericState<ContactNameModel>(),
};

const contactReducers = [
  ...onApiCall<ContactDetailModel>(contactActions.getById, 'getById'),
  ...onApiCall<ContactFormModel>(contactActions.getFormById, 'getFormById'),
  ...onApiCall<ContactModel>(contactActions.postContact, 'postContact'),
  ...onApiCall<ContactModel>(contactActions.updateContact, 'updateContact'),
  ...onApiCall<ContactModel>(contactActions.createInstance, 'createInstance'),
  ...onApiCall<ContactChildrenLightModel[]>(
    contactActions.getChildren,
    'getChildren',
  ),
  ...onApiCall<ContactNameModel>(
    contactActions.getNewestContactNameByEmail,
    'getNewestContactNameByEmail',
  ),
];

export const contactReducer = createReducer(
  contactInitialState,
  ...contactReducers,
) as ActionReducer<IContactState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return contactReducer(state, action);
}
